import { Button } from '@ahmdigital/ui';
import styled from 'styled-components';

const filterBarBorder = '1px solid';
const wrapperMargin = '1rem';

export const Wrapper = styled.div`
  border: ${filterBarBorder} ${({ theme }) => theme.colors.grey20};
  border-radius: 0.25rem;
  margin: ${wrapperMargin} ${wrapperMargin} 0 ${wrapperMargin};

  @media (min-width: ${({ theme }) => theme.media.md}) {
    align-items: center;
    border: none;
    display: flex;
    justify-content: center;
    margin-bottom: ${wrapperMargin};
  }
`;

export const ExtrasComparerWrapper = styled.div<{ fullWidth: boolean }>`
  display: flex;

  & *:nth-last-child(-n + 2) {
    width: ${(props) => (props.fullWidth ? '100%' : '50%')};
  }

  @media (min-width: ${({ theme }) => theme.media.md}) {
    & *:last-child {
      border-right: none;
    }

    & *:nth-last-child(-n + 2) {
      width: fit-content;
    }
  }
`;

export const FlexWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.25rem;
  box-shadow: 0 0.5rem 1rem 0 rgba(17, 17, 17, 0.04);
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  position: relative;
  z-index: 999;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    border-radius: 3.75rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 auto;
    min-height: 4.5rem;
  }
`;

export const FilterBarWrapper = styled.div`
  display: flex;
  justify-content: center;
  @media (min-width: ${({ theme }) => theme.media.md}) {
    margin: 0 auto;
  }
`;

export const StyledButton = styled(Button)`
  border-radius: 2.5rem;
  margin: ${wrapperMargin};
  white-space: nowrap;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    margin: 0.75rem 0.75rem 0.75rem 0;
    white-space: nowrap;
  }
`;

export const StyledDiv = styled.div`
  border: ${filterBarBorder} ${({ theme }) => theme.colors.grey20};
  padding-bottom: 0.75rem;
  padding-left: 1.25rem;
  padding-top: 0.75rem;
  text-align: left;
  white-space: nowrap;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    border: none;
    border-right: ${filterBarBorder} ${({ theme }) => theme.colors.grey20};
    display: flex;
    flex-direction: column;
    font-size: $base-font-size-small;
    padding: 0 20px;
  }
`;
